// extracted by mini-css-extract-plugin
export default {"container":"SwitchUpYour_container__zOWYR","slider":"SwitchUpYour_slider__CWsVE","fixedSpan":"SwitchUpYour_fixedSpan__XpBxv","sliderValue":"SwitchUpYour_sliderValue__9atqP"};